(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bron-hydration-control-gift"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('[data-hydration-gift-choose]');if(!link)return;const hero=document.querySelector('[data-bron-hydration-hero]');if(!hero)return;event.preventDefault();const one=hero.querySelector('[data-bron-mode="one"]');if(one)one.click();const tier=hero.querySelector('[data-bron-purchase][data-qty="3"]');if(tier)tier.click();hero.querySelector('.bron-hero-content').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bron-line-control-gift"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('[data-line-gift-choose]');if(!link)return;const hero=document.querySelector('[data-bron-line-hero]');if(!hero)return;event.preventDefault();const one=hero.querySelector('[data-bron-mode="one"]');if(one)one.click();const tier=hero.querySelector('[data-bron-purchase][data-qty="3"]');if(tier)tier.click();hero.querySelector('.bron-hero-content').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bron-line-control"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('.lc-form');
    if (!form) return;
    const image = root.querySelector('[data-lc-image]');
    const tiers = [...root.querySelectorAll('.lc-tier input')];
    const modes = [...root.querySelectorAll('.lc-mode input')];
    const submit = form.querySelector('[type=submit]');
    const status = root.querySelector('[data-lc-status]');
    const sticky = root.querySelector('[data-lc-sticky]');
    const stickyButton = root.querySelector('[data-lc-sticky-add]');
    const note = root.querySelector('[data-lc-note]');
    const oneNote = note.textContent;
    let busy = false;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency || 'USD'});
    const money = value => formatter.format(Number(value) / 100);
    const selected = () => tiers.find(t => t.checked);
    const subscribed = () => modes.some(m => m.checked && m.value === 'sub');
    function setImage(src, alt) {
      if (!image || !src) return;
      image.removeAttribute('srcset'); image.removeAttribute('sizes');
      image.src = src; image.alt = alt;
      root.querySelectorAll('[data-lc-view]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.src === src)));
    }
    function sync() {
      const tier = selected(); if (!tier) return;
      const sub = subscribed(); const price = sub ? tier.dataset.subPrice : tier.dataset.price;
      root.classList.toggle('is-sub', sub);
      form.elements.quantity.value = tier.value;
      form.elements.selling_plan.value = sub ? tier.dataset.plan : '';
      form.elements.selling_plan.disabled = !sub;
      tiers.forEach(t => t.closest('label').querySelector('[data-tier-price]').textContent = money(sub ? t.dataset.subPrice : t.dataset.price));
      root.querySelector('[data-lc-total]').textContent = money(price);
      root.querySelector('[data-lc-sticky-price]').textContent = money(price);
      root.querySelector('[data-lc-sticky-info]').textContent = `${tier.dataset.days}-day plan · ${sub ? 'Subscription' : 'One-time'}`;
      note.textContent = sub ? `${money(price)} every ${tier.dataset.days} days for ${tier.value} ${tier.value === '1' ? 'bottle' : 'bottles'}. Renews automatically. Skip, pause, or cancel anytime. No gifts on subscriptions.` : oneNote;
      const hasGift = !sub && tier.value === '3' && root.dataset.gift;
      setImage(hasGift ? root.dataset.bundle : root.dataset.hero, hasGift ? 'Three LINE CONTROL bottles with a free charcoal soap bar' : 'BRÖN LINE CONTROL night serum');
      const disabled = root.dataset.available !== 'true' || (sub && !tier.dataset.plan) || busy;
      submit.disabled = disabled; stickyButton.disabled = disabled;
    }
    tiers.concat(modes).forEach(input => input.addEventListener('change', sync));
    root.querySelectorAll('[data-lc-view]').forEach(button => button.addEventListener('click', () => setImage(button.dataset.src, button.dataset.alt)));
    root.querySelectorAll('[data-lc-gift-cta]').forEach(button => button.addEventListener('click', () => {
      modes.find(m => m.value === 'one').checked = true; tiers.find(t => t.value === '3').checked = true; sync();
      root.querySelector('.lc-buybox').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
    }));
    async function add(event) {
      event.preventDefault(); if (busy || submit.disabled) return;
      busy = true; sync(); status.textContent = ''; root.querySelector('[data-lc-add-label]').textContent = 'ADDING…';
      const tier = selected(); const sub = subscribed();
      const item = {id:Number(form.elements.id.value), quantity:Number(tier.value)};
      if (sub) item.selling_plan = Number(tier.dataset.plan);
      const items = [item];
      if (!sub && tier.value === '3' && root.dataset.gift) items.push({id:Number(root.dataset.gift),quantity:1});
      try {
        const response = await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const data = await response.json(); if (!response.ok) throw new Error(data.description || data.message || 'Could not add this plan. Please try again.');
        document.dispatchEvent(new CustomEvent('bron:cart:added',{detail:data}));
        status.replaceChildren(document.createTextNode('Added to your cart. '));
        const link = document.createElement('a'); link.href=root.dataset.cartUrl;link.textContent='View cart';status.append(link);
      } catch(error) { status.textContent = error.message || 'Connection interrupted. Check your cart before trying again.'; }
      finally { busy=false;sync();root.querySelector('[data-lc-add-label]').textContent='GET LINE CONTROL'; }
    }
    form.addEventListener('submit', add);
    stickyButton.addEventListener('click', () => form.requestSubmit());
    const observer = new IntersectionObserver(entries => {const rect=entries[0].boundingClientRect;sticky.hidden=entries[0].isIntersecting || rect.top>0;},{threshold:0});
    observer.observe(submit);
    root.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
    sync();
  }
  document.querySelectorAll('[data-line-control]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-line-control]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
